import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE from "./config";

function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    console.log("开始登录，用户名:", username, "密码:", password); // 👈 加这行

    try {
      const res = await fetch(`${API_BASE}/api/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      console.log("响应状态:", res.status); // 👈 加这行
      const data = await res.json();
      console.log("响应数据:", data); // 👈 加这行

      if (data.success) {
        localStorage.setItem("adminToken", data.token);
        console.log("登录成功，准备跳转到 /admin/articles"); // 👈 加这行
        navigate("/admin/articles");
      } else {
        setError(data.error || "登录失败");
        console.log("登录失败:", data.error); // 👈 加这行
      }
    } catch (err) {
      setError("网络错误，请检查后端是否启动");
      console.error("Fetch 错误:", err); // 👈 加这行
    }
  };
  return (
    <div style={{ maxWidth: "400px", margin: "100px auto", padding: "2rem" }}>
      <h2>管理员登录</h2>
      <form onSubmit={handleLogin}>
        <input
          type="text"
          placeholder="用户名"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />
        <input
          type="password"
          placeholder="密码"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />
        {error && <p style={{ color: "red" }}>{error}</p>}
        <button type="submit" style={{ width: "100%", padding: "0.5rem" }}>
          登录
        </button>
      </form>
    </div>
  );
}

export default AdminLogin;
